interface IComponentIsVisibleProps {
  children: React.ReactNode;
  when: boolean;
}

const ComponentIsVisible = ({
  children,
  when,
}: IComponentIsVisibleProps): JSX.Element => {
  return <>{when && children}</>;
};

export default ComponentIsVisible;
